import XLSX from 'xlsx';
import moment from 'moment';

export default {
  methods: {
    exportXLSRptGenExpertos (reporte) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Base",
        Subject: "Base",
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };

      let columns = [];

      // columns.push('Mes');
      columns.push('Etapa');
      columns.push('Fecha de Inicio');
      columns.push('Cadena');
      columns.push('ID');
      columns.push('CPA');
      columns.push('Nombre de Tienda');
      columns.push('Nombre Promotor');
      columns.push('Calle');
      columns.push('Numero');
      columns.push('Telefono');
      columns.push('Correo Electrónico');
      columns.push('Titular');
      columns.push('CUIT');
      columns.push('CVU');
      columns.push('CBU Banco');
      columns.push('Plasticos');

      if (reporte.etapas) {
        reporte.etapas.forEach(etapa => {
          columns.push(`ESTADO ${etapa.nombre.trim()}`);
          columns.push(`IMPORTE ${etapa.nombre.trim()}`);
          columns.push(`FECHA TRANSF. ${etapa.nombre.trim()}`);
        });
      }

      let data = [ [] ];
      data.push([ ...columns ]);

      if (reporte.participantes) {
        let participanteId = 0;

        reporte.participantes.forEach(participante => {
          let dataParticipante = [];

          if (participanteId != parseInt(participante.id)) {
            participanteId = parseInt(participante.id);

            // dataParticipante.push(participante.mesInicial.trim());
            dataParticipante.push(participante.etapa.trim());
            dataParticipante.push(this.$options.filters.fecha(participante.fechaInicioEtapa));
            dataParticipante.push(participante.cadena.trim()); 
            dataParticipante.push(participante.codigoPromocion.trim());
            dataParticipante.push(participante.codigoPostal.trim());
            dataParticipante.push(participante.negocio.trim());
            dataParticipante.push(participante.vendedor.trim());
            dataParticipante.push(participante.direccionCalle.trim());
            dataParticipante.push(participante.direccionNumero.toString().trim());
            dataParticipante.push(participante.telefono.trim());
            dataParticipante.push(participante.email.trim());
            dataParticipante.push(participante.titular.trim());
            dataParticipante.push(participante.cuit.trim());
            dataParticipante.push(participante.cvu.trim());
            dataParticipante.push(participante.cbu.trim());
            dataParticipante.push(participante.plasticos.trim());
          } else {
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push(participante.codigoPromocion.trim()); 
            // dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
            dataParticipante.push('');
          }

          if (participante.participanteEtapas) {
            if (reporte.etapas) {
              reporte.etapas.forEach(etapa => {
                let participanteEtapa = participante.participanteEtapas.find(t => t.eventoEtapaId == etapa.id);
                if (participanteEtapa) {
                  dataParticipante.push(participanteEtapa.estado);
                  dataParticipante.push(participanteEtapa.importe);
                  dataParticipante.push(this.$options.filters.fecha(participanteEtapa.fechaUltimaTransferencia));
                } else {
                  // dataParticipante.push('No corresponde'); /* Estado */
                  // dataParticipante.push((/true/i).test(participante.transferenciasCompletadas) ? 'No corresponde' : ''); /* Estado */
                  dataParticipante.push(''); /* Estado */
                  dataParticipante.push(''); /* Importe */
                  dataParticipante.push(''); /* Fecha */
                }
              });
            }
          }

          data.push([ ...dataParticipante ]);
        });
      }

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Base");

      XLSX.writeFile(wb, 'reporte_base.xlsx');
      return;
    },
  }
}
